import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Refunds = () => {
  return (
    <section className="min-h-screen bg-[#0A0E14] pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Cancellation & Refunds</h1>
        <p className="text-gray-400 mb-12">Last updated: January 2025</p>

        <div className="glass-card rounded-2xl p-8 md:p-12 space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Cancellation Policy</h2>
            <p className="leading-relaxed mb-4">
              You may cancel your MBhost subscription at any time through your account dashboard or by contacting our support team. Cancellations are processed as follows:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Monthly Plans:</strong> Cancellation takes effect at the end of the current billing period</li>
              <li><strong>Annual Plans:</strong> Cancellation takes effect at the end of the annual term</li>
              <li><strong>Free Trial:</strong> Can be cancelled anytime during the trial period</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Refund Eligibility</h2>
            <p className="leading-relaxed mb-4">
              MBhost offers refunds under the following conditions:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>7-Day Money-Back Guarantee:</strong> Full refund available within 7 days of initial signup for new customers</li>
              <li><strong>Service Outages:</strong> Pro-rated refunds for extended outages beyond our SLA commitment</li>
              <li><strong>Billing Errors:</strong> Full refund for any billing mistakes on our part</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Non-Refundable Items</h2>
            <p className="leading-relaxed mb-4">
              The following are not eligible for refunds:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Domain registration fees</li>
              <li>SSL certificate purchases</li>
              <li>Setup fees and migration services</li>
              <li>Add-on services after 7-day period</li>
              <li>Partial month charges after cancellation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Refund Process</h2>
            <p className="leading-relaxed mb-4">
              To request a refund:
            </p>
            <ol className="list-decimal list-inside space-y-2 ml-4">
              <li>Contact our support team at <span className="text-green-400">support@mbhost.in</span></li>
              <li>Provide your account details and reason for refund</li>
              <li>Our team will review your request within 2-3 business days</li>
              <li>Approved refunds are processed within 7-10 business days</li>
              <li>Refunds are issued to the original payment method</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Service Credits</h2>
            <p className="leading-relaxed">
              In cases where refunds are not applicable, we may offer service credits that can be applied to future billing cycles. Service credits do not expire and are automatically applied to your next invoice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Downgrade Policy</h2>
            <p className="leading-relaxed">
              If you downgrade your plan, the change takes effect at the start of the next billing cycle. No refunds are provided for downgrades, but you retain access to your current plan features until the end of the billing period.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Account Termination</h2>
            <p className="leading-relaxed">
              Upon cancellation, you have 30 days to export your data before account termination. After this period, all data is permanently deleted and cannot be recovered.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Disputes</h2>
            <p className="leading-relaxed">
              If you have a billing dispute, please contact our support team immediately. We are committed to resolving all issues fairly and promptly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Contact Us</h2>
            <p className="leading-relaxed">
              For cancellation or refund requests, contact:
              <br />
              Email: <span className="text-green-400">support@mbhost.in</span>
              <br />
              Phone: +91-XXXX-XXXXXX
              <br />
              MBhost Cloud Pvt Ltd, A unit of MBT Ventures Ltd.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};